module.exports = __webpack_public_path__ + "img/Hawaiian Poke Wrap-Chicken.d5b15103.jpg";